<main class="container-fluid">
  <section class="row bg-white shadow mb-3 mt-3 ml-0 mr-0">
    <div class="col-3 border-right p-4 mt-5 mb-5">
      <header class="text-center mb-3">
        Editar parámetros de días hábiles para municipios
      </header>

      <form [formGroup]="formAtencionSolicitudDias" (ngSubmit)="save()">
        <label class="small text-secondary font-weight-bold mt-2" for="dias">Días limite</label>
        <input type="number" id="inputDias" class="form-control form-control-sm" min="1" formControlName="dias">

        <label class="small text-secondary font-weight-bold mt-2" for="depto">Departamento</label>
        <input type="text" id="depto" class="form-control form-control-sm" formControlName="depto">

        <label class="small text-secondary font-weight-bold mt-2" for="municipio">Municipio</label>
        <input type="text" id="municipio" class="form-control form-control-sm" formControlName="municipio">

        <label class="small text-secondary font-weight-bold mt-2" for="municipio">Opcion</label>
        <select class="form-control form-control-sm" id="activo" formControlName="option">
          <option value="">Seleccione</option>
          <option value="1">Aplica solo al Municipio</option>
          <option value="0">Aplica a todo el departamento</option>
        </select>

        <div class="d-flex flex-row mt-4">
          <button type="reset" (click)="clearForm()" class="btn btn-outline-primary border-0 m-auto">Limpiar</button>

          <button class="btn btn-primary m-auto solicitud-btn-principal"
          type="submit" [disabled]="!formAtencionSolicitudDias.valid">
            Guardar
          </button>
        </div>
      </form>
    </div>

    <div  class="col-9 p-4 mt-5 mb-5">
      <div class="d-flex justify-content-between mb-4">
        <div>
          <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block img-responsive mr-3" alt="">
          <span class="h5">Listado de municipios</span>
        </div>

        <div>
          <button type="button" class="btn btn-outline-primary" (click)="isCollapsed = !isCollapsed"
            [attr.aria-expanded]="!isCollapsed" aria-controls="filtros">
            Ver filtros
          </button>
        </div>
      </div>

      <!-- Filtros -->
      <div id="filtros" [ngbCollapse]="isCollapsed" class="mb-4">
        <form [formGroup]="formFilterAtencionSolicitudDias" (ngSubmit)="saveFilter()">
          <div class="row">
            <div class="col-md-3">
              <label for="departamentoFilter" class="small">Departamento</label>
              <select class="form-control form-control-sm" formControlName="departamentoFilter" (change)="getMunicipio($event)">
                <option value=""></option>
                <option value="{{item.departamento_id}}" *ngFor="let item of departamento">{{item.descripcion}}</option>
              </select>
            </div>

            <div class="col-md-3">
              <label for="municipioFilter" class="small">Municipio</label>
              <select class="form-control form-control-sm" formControlName="municipioFilter">
                <option value=""></option>
                <option value="{{itemM.municipio_id}}" *ngFor="let itemM of municipio">{{itemM.descripcion}}</option>
              </select>
            </div>

            <div class="col-md-3">
              <label for="camaraFilter" class="small">Camara</label>
              <select class="form-control form-control-sm" formControlName="camaraFilter">
                <option value=""></option>
                <option value="{{camara.codigo_camara}}" *ngFor="let camara of camarasComercios">{{camara.desc_camara}}</option>
              </select>
            </div>

            <div class="col-md-3">
              <br>
              <button type="reset" (click)="clearFormFilter()" class="btn btn-outline-primary border-0 m-auto">
                Limpiar
              </button>

              <button class="btn btn-primary m-auto solicitud-btn-principal" type="submit">
                Filtrar
              </button>
            </div>
          </div>
        </form>
      </div>

      <div class="table-responsive">
        <app-tablas class="table-responsive" [page]="paginaActual" [headers]="headertblAtencionSolicitudDias"
        [sizeData]="dataTable.paging.totalItems" (paginado)="onPaginado($event)">
          <tr *ngFor="let item of dataTable.items; let i=index" class="small">
            <td>{{item.descripcion_departamento}}</td>
            <td>{{item.descripcion_municipio}}</td>
            <td>{{item.descripcion_camara}}</td>
            <td>{{item.dias_aprob_rech_solicitud}}</td>
            <td>
              <img src="../../../../../../../../assets/icons/edit.png" class="pointer" alt="" height="25"
              (click)="editarDiasHabiles(item)">
            </td>
          </tr>
        </app-tablas>
      </div>
    </div>
  </section>
</main>
